class AdvertService {
  constructor(
    ApiService,
    $q,
    AdvertSchema,
    Upload,
    LinkTypeService,
    LoaderService,
    AlertService
  ) {
    this.$q = $q;
    this.ApiService = ApiService;
    this.Upload = Upload;
    this.AdvertSchema = AdvertSchema;
    this.LinkTypeService = LinkTypeService;
    this.LoaderService = LoaderService;
    this.AlertService = AlertService;

    this.advertEndpoint = '/api/adverts';
    this.imageEndpoint = '/api/upload';
    this.advertOrderEndpoint = '/api/adverts/reorder/';
    this.ADVERT_TYPE_FEATURE_ID = 1;
    this.ADVERT_TYPE_INLINE_ID = 2;
    this.ADVERT_TYPE_EXPERIENCE_ID = 3;
    this.ADVERT_TYPES = {
      feature: this.ADVERT_TYPE_FEATURE_ID,
      inline: this.ADVERT_TYPE_INLINE_ID,
      experience: this.ADVERT_TYPE_EXPERIENCE_ID
    };
  }

  getNew() {
    return this.AdvertSchema;
  }

  getById(id) {
    var self = this;
    return self.ApiService
      .get(self.advertEndpoint + '/' + id)
      .then(response => {
        return response.data;
      });
  }

  getAllFeatureCarouselAdverts() {
    var self = this;
    var order = encodeURI('?order[rank]=ASC');
    return self.ApiService.get(self.advertEndpoint + order).then(response => {
      var featuredAdverts = [];
      angular.forEach(response.data, function(advert) {
        if (advert.type.name === 'Feature') {
          // We injected AdvertService into each advert due to lost scope in
          // dnd custom sorting directive
          advert.advertService = self;
          featuredAdverts.push(advert);
        }
      });
      return featuredAdverts;
    });
  }

  getAllExperienceCarouselAdverts() {
    var self = this;
    var order = encodeURI('?order[rank]=ASC');
    return self.ApiService.get(self.advertEndpoint + order).then(response => {
      var featuredAdverts = [];
      angular.forEach(response.data, function(advert) {
        if (advert.type.name === 'Experience') {
          // We injected AdvertService into each advert due to lost scope in
          // dnd custom sorting directive
          advert.advertService = self;
          featuredAdverts.push(advert);
        }
      });
      return featuredAdverts;
    });
  }

  getAllInlineAdverts() {
    var self = this;
    var order = encodeURI('?order[rank]=ASC');
    return self.ApiService.get(self.advertEndpoint + order).then(response => {
      var featuredAdverts = [];
      angular.forEach(response.data, function(advert) {
        if (advert.type.name === 'Inline') {
          // We injected AdvertService into each advert due to lost scope in
          // dnd custom sorting directive
          advert.advertService = self;
          featuredAdverts.push(advert);
        }
      });
      return featuredAdverts;
    });
  }

  changeState(advert, newState, type) {
    // We removed AdvertService to stop recursive copy
    advert.advertService = null;
    var advertCopy = angular.copy(advert);
    var self = this;
    advertCopy.type = this.ADVERT_TYPES[type];
    if (newState == 'active') {
      advertCopy.active = true;
    } else {
      advertCopy.active = false;
    }
    advertCopy = self.stripUnnecessaryFields(advertCopy);
    var linkValues = {};
    if (advertCopy.linkType && advertCopy.linkValue) {
      advertCopy.linkType = advertCopy.linkType.id;
      advertCopy.linkValue = advertCopy.linkValue;
    }
    return self.ApiService
      .put(self.advertEndpoint + '/' + advertCopy.id, advertCopy)
      .then(res => {
        // We injected AdvertService into each advert due to lost scope in dnd custom sorting directive
        advert.advertService = self;
        advert.active = res.data.active;
        return self.AlertService.success('Advert state changed successfully');
      })
      .catch(error =>
        self.AlertService.error('There was a problem getting the Adverts')
      );
  }

  reorder(adverts, type) {
    var self = this;
    var ids = [];
    angular.forEach(adverts, advert => {
      ids.push(advert.id);
    });

    return self.ApiService.post(self.advertOrderEndpoint + type, ids);
  }

  saveImage(file, imageType) {
    var self = this;

    if (file) {
      return self.Upload
        .upload({
          url: self.imageEndpoint + imageType,
          data: { file: file }
        })
        .catch(response => {
          var error = {
            type: 'image',
            message: 'Unknown error saving the advert'
          };
          if (response.data.error) {
            error.message = response.data.message;
          }
          return self.$q.reject(error);
        });
    } else {
      return self.$q.when(null);
    }
  }

  addNew(advert, file) {
    var self = this;

    var imageType = '/header';
    if (advert.type === 2) {
      imageType = '/inline';
    } else if (advert.type === 3) {
      imageType = '/experience';
    }

    // save the image
    return self.saveImage(file, imageType).then(function(response) {
      // add image details to raceday object
      advert.largeImageUrl = response.data.large_image.url;
      advert.mediumImageUrl = response.data.medium_image.url;

      if (advert.socialCategory) {
        advert.socialCategory = advert.socialCategory.id;
      }

      // save the advert
      return self.ApiService.post(self.advertEndpoint, advert);
    });
  }

  update(advert, file) {
    var self = this;

    var imageType = '/header';
    if (advert.type === 2) {
      imageType = '/inline';
    } else if (advert.type === 3) {
      imageType = '/experience';
    }

    advert = self.stripUnnecessaryFields(advert);
    //advert.type = advert.type.id;

    // save the image
    return self.saveImage(file, imageType).then(function(response) {
      if (response) {
        // add image details to raceday object
        advert.largeImageUrl = response.data.large_image.url;
        advert.mediumImageUrl = response.data.medium_image.url;
      }

      if (advert.socialCategory) {
        advert.socialCategory = advert.socialCategory.id;
      }

      // save the advert
      return self.ApiService.put(self.advertEndpoint + '/' + advert.id, advert);
    });
  }

  deleteAdvert(advertId) {
    var self = this;
    return self.ApiService._delete(self.advertEndpoint + '/' + advertId);
  }

  stripUnnecessaryFields(advert) {
    var tmpLinkValue = advert.linkValue;
    if (advert.linkValue !== null && typeof advert.linkValue === 'object') {
      tmpLinkValue = advert.linkValue.id;
    }

    var tmpSocialCatValue = advert.socialCategory;
    if (
      advert.linkValue !== null &&
      advert.socialCategory !== null &&
      typeof advert.socialCategory === 'object'
    ) {
      tmpSocialCatValue = advert.socialCategory.id;
    }

    var formattedAdvert = {
      id: advert.id,
      title: advert.title,
      description: advert.description,
      type: advert.type,
      socialCategory: tmpSocialCatValue,
      linkType: advert.linkType,
      largeImageUrl: advert.largeImageUrl,
      mediumImageUrl: advert.mediumImageUrl,
      linkValue: tmpLinkValue,
      active: advert.active
    };
    return formattedAdvert;
  }

  processLinkTypes(advert, linkValues) {
    var self = this;
    var linkTypeText = null;
    return self.LinkTypeService.getAll().then(linkTypes => {
      for (var i = 0; i < linkTypes.length; i++) {
        if (advert.linkType === linkTypes[i].id) {
          linkTypeText = linkTypes[i].name;
        }
      }
      if (linkTypeText) {
        advert.linkValue =
          linkValues[linkTypeText.toLowerCase().replace(' ', '_')];
      } else {
        advert.linkValue = null;
        advert.linkType = null;
      }
      return advert;
    });
  }
}
AdvertService.$inject = [
  'ApiService',
  '$q',
  'AdvertSchema',
  'Upload',
  'LinkTypeService',
  'LoaderService',
  'AlertService'
];
export default AdvertService;
